import {ticketTypes,ticketSeverities} from './ticketDisplay'
export default function TicketClassification({ticket}:{ticket?:Record<string,unknown>}){
 const type=typeof ticket?.ticket_type==='string'?ticketTypes[ticket.ticket_type]:undefined
 const severity=typeof ticket?.bug_severity==='string'?ticketSeverities[ticket.bug_severity]:undefined
 if(!type&&!severity)return null
 return <span className="cc-ticket-classification" style={{display:'block'}}>{type&&<>סוג: {type}</>}{type&&severity?' · ':''}{severity&&<>חומרה: {severity}</>}</span>
}
